import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs'; 
import { CondicionVentaDto } from '../models/condi-fiscal.dto';

@Injectable({
  providedIn: 'root'
})
export class CondiVentaService {
  private apiUrl = ``;
  private entity = `condi-venta`;

  constructor(private http: HttpClient) {

    if (environment.production)
      this.apiUrl = environment.apiUrl + this.entity;
    else
      this.apiUrl = environment.apiUrlDev + this.entity;

  }


  getAll(): Observable<CondicionVentaDto[]> {
    return this.http.get<CondicionVentaDto[]>(this.apiUrl);
  }

}
